<template>
    <div>
        <div class="row" id="headlines-page">
            <div class="col-lg-12 mt-3 mb-1 text-center" id="headlines">
                <div :class="{active: $route.name === 'initial-bank'}" class="headline-item mb-2" @click="onHeadlineClicked('initial-bank')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>بانک</h5>
                </div>
                <div :class="{active: $route.name === 'initial-provider'}" class="headline-item mb-2" @click="onHeadlineClicked('initial-provider')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>تامین کننده</h5>
                </div>
                <div :class="{active: $route.name === 'initial-cash-desk'}" class="headline-item mb-2" @click="onHeadlineClicked('initial-cash-desk')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>صندوق</h5>
                </div>
                <div :class="{active: $route.name === 'initial-customer'}" class="headline-item mb-2" @click="onHeadlineClicked('initial-customer')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>مشتری</h5>
                </div>
                <div :class="{active: $route.name === 'initial-product'}" class="headline-item mb-2" @click="onHeadlineClicked('initial-product')">
                    <h5>محصولات</h5>
                </div>
            </div>
            <div class="col-lg-12 mt-2">
                <transition
                        name="fade"
                        mode="out-in"
                >
                    <router-view/>
                </transition>
            </div>
            <div class="sk-circle" id="loading">
                <div class="sk-circle1 sk-child"></div>
                <div class="sk-circle2 sk-child"></div>
                <div class="sk-circle3 sk-child"></div>
                <div class="sk-circle4 sk-child"></div>
                <div class="sk-circle5 sk-child"></div>
                <div class="sk-circle6 sk-child"></div>
                <div class="sk-circle7 sk-child"></div>
                <div class="sk-circle8 sk-child"></div>
                <div class="sk-circle9 sk-child"></div>
                <div class="sk-circle10 sk-child"></div>
                <div class="sk-circle11 sk-child"></div>
                <div class="sk-circle12 sk-child"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    $(function() {
        var pos1 = 0;
        $(window).scroll(function() {
            var pos2 = $(window).scrollTop();
            if(pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if(pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(()=> {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'initial-balance',
        components: {},
        data() {
            return {
                companyPostName:"",
            }
        } ,
        mounted() {
            this.companyPostName = localStorage.getItem("companyPostName");

            $("#loading").hide();
        },
        methods: {
            onHeadlineClicked(headline) {
                this.$router.push({
                    name: `${headline}`,

                });
            }
        }
    }
</script>

<style scoped>
    #loading {
        position: absolute;
        top: calc(40% - 40px);
        left: calc(50% - 40px);
    }
</style>